import _sfc_main from "./DarkModeToggle.vue2.js";
import _export_sfc from "../_virtual/_plugin-vue_export-helper.js";
const DarkModeToggle = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-c0aca727"]]);
export {
  DarkModeToggle as default
};
//# sourceMappingURL=DarkModeToggle.vue.js.map
